import { useNavigate } from 'react-router-dom';

export default function Footer({ setActivePage }) {
  const navigate = useNavigate();

  const go = (pageId) => {
    navigate('/');
    setActivePage(pageId);
  };

  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Pranavi&apos;s Kitchen</p>
      <div className="footer-links">
        <button type="button" onClick={() => go('about')}>
          About Us
        </button>
        <button type="button" onClick={() => go('terms')}>
          Terms & Conditions
        </button>
      </div>
    </footer>
  );
}
